(ns com.theplantscape.web-ui.tailwind.images)


(defn picture [{:keys [image alt width]}]
  [:picture
   [:source {:media "(min-width: 800px;)" :srcSet (str image "?p")}]
   [:img.object-cover
    {:src image
     :width width
     :alt alt
     :decoding "async"
     :loading "lazy"}]])
